// ローディング時の処理
window.addEventListener('load', (event) => {
  const spinner = document.getElementById('loading');
  spinner.classList.add('loaded');
  const page = document.getElementById('page');
  page.style.display = 'block';
});
// スマホでヒーローを全画面にする
// function setHeight() {
//   let vh = window.innerHeight * 0.01;
//   document.documentElement.style.setProperty('--vh', `${vh}px`);
// }
// setHeight();
